export default __webpack_public_path__ + "static/media/Kerala_Normal.f3f07ff9.svg";